import { FlexColumn, LabeledData, useMoment } from '@gorila-shared-ui/components';
import { MEDIA_TYPES } from '../../constants/reports';
import { useStyles } from '../../hooks/useStyles';
import { EvidenceMetadata } from '../../types/evidences';
import { getMediaTypeLabel } from '../../utils/media';
import { isNotEmptyObject, objectHasKey } from '../../utils/objects';
import DataDescription from '../shared/DataDescription';

type Props = {
  metadata?: EvidenceMetadata;
  wrap?: boolean;
  url?: string;
};

function EvidenceMetadataDisplay({ metadata, wrap = false, url }: Readonly<Props>) {
  const { theme } = useStyles();
  const { formatDateFromTs } = useMoment();
  const hasMetadata = isNotEmptyObject(metadata);
  const mediaTypeLabel = getMediaTypeLabel(url) || MEDIA_TYPES.VIDEO;

  if (!hasMetadata) return null;

  if (wrap) {
    return (
      <FlexColumn gap={theme.sizing.scale200}>
        {objectHasKey(metadata!, 'startDate') && metadata?.startDate !== undefined && (
          <DataDescription
            label={`Fecha de ${mediaTypeLabel}:`}
            content={formatDateFromTs(metadata.startDate)}
          />
        )}
        {objectHasKey(metadata!, 'duration') && metadata?.duration !== undefined && (
          <DataDescription
            label="Duración:"
            content={metadata.duration + 's'}
          />
        )}
      </FlexColumn>
    );
  }

  return (
    <FlexColumn gap={theme.sizing.scale200}>
      {objectHasKey(metadata!, 'startDate') && metadata?.startDate !== undefined && (
        <LabeledData
          label={`Fecha de ${mediaTypeLabel}:`}
          content={formatDateFromTs(metadata.startDate)}
        />
      )}
      {objectHasKey(metadata!, 'duration') && metadata?.duration !== undefined && (
        <LabeledData
          label={'Duración:'}
          content={metadata.duration + 's'}
        />
      )}
    </FlexColumn>
  );
}

export default EvidenceMetadataDisplay;
